import { getAuth } from '../app/modules/auth/core/AuthHelpers';
import { noteInterpreterEndingCall } from './agentNetworkTelemetry/ccpEvents';

/**
 * Shared POST for set-ended-by-interpreter.
 * Used by streamsStore (network-drop auto-end) and manual End Call.
 */
export async function postSetCallEndedByInterpreter(code: number): Promise<void> {
  try {
    noteInterpreterEndingCall();
  } catch {
    /* telemetry only — never block the end-call request */
  }
  const baseUrl = process.env.REACT_APP_API_URL || '';
  const auth = getAuth();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (auth?.isAuthenticated && auth.token) {
    headers.Authorization = `Bearer ${auth.token}`;
  }

  const response = await fetch(
    `${baseUrl}/aws-connect/v4/call-header/set-ended-by-interpreter`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify({ code }),
    },
  );

  if (!response.ok) {
    const body = await response.text().catch(() => '');
    throw new Error(
      `set-ended-by-interpreter failed (${response.status})${body ? `: ${body}` : ''}`,
    );
  }
}
